export default "__VITE_ASSET__CmS8AT4t__"